import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import TableHeader from "../../../../../components/Table/TableHeader";
import TablePagination from "../../../../../components/Table/TablePagination";
import { retornarStatusContrato } from "../../../../../services/utils";

const tabelaColunas = [
  "Razão Social",
  "Nome Fantasia",
  "CNPJ",
  "Status",
  "Status Contrato",
  "",
];

const ListBuyer = ({ data, mudarPagina, buscar, busca }) => {
  const history = useHistory();
  const [novaLista, setNovaLista] = useState([]);

  const changePage = (page) => {
    mudarPagina(page);
  };

  const gotoDet = (userId) => {
    history.push(`/admin/buyer/${userId}`);
  };

  useEffect(() => {
    setNovaLista(data.lista);
  }, [data]);

  return (
    <div className="buyers-lista">
      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.razaoSocial - b.razaoSocial
                      );
                      const isReversed =
                        novaLista[0]?.razaoSocial === sorted[0]?.razaoSocial;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Razão Social
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.nomeFantasia - b.nomeFantasia
                      );
                      const isReversed =
                        novaLista[0]?.nomeFantasia === sorted[0]?.nomeFantasia;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Nome Fantasia
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.cnpj - b.cnpj);
                      const isReversed = novaLista[0]?.cnpj === sorted[0]?.cnpj;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    CNPJ
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.ativo - b.ativo);
                      const isReversed = novaLista[0]?.ativo === sorted[0]?.ativo;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.statusContrato - b.statusContrato
                      );
                      const isReversed =
                        novaLista[0]?.statusContrato === sorted[0]?.statusContrato;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Status Contrato
                  </th>
                  <th style={{ cursor: "pointer" }}></th>
                </tr>
              </thead>
              <tbody>
                {(!novaLista || novaLista.length === 0) && (
                  <tr>
                    <td colSpan={tabelaColunas.length}> Sem Registros </td>
                  </tr>
                )}
                {novaLista &&
                  novaLista.map((buyer) => (
                    <tr key={buyer.id}>
                      <td> {buyer.razaoSocial} </td>
                      <td> {buyer.nomeFantasia} </td>
                      <td> {buyer.cnpj} </td>
                      <td> {buyer.ativo ? "Ativo" : "Inativo"} </td>
                      <td> {retornarStatusContrato(buyer.statusContrato)} </td>
                      <td className="text-right">
                        <i
                          className="btn-edit-icon btn btn-icon fa fa-edit"
                          onClick={() => gotoDet(buyer.id)}
                        ></i>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <TablePagination data={data} changePage={changePage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListBuyer;
